<div id="extraContent4">
    <div class="table-cell" style="max-width: 1px;  overflow: visible; white-space: nowrap; height: 380px">
        <div class="absolute right-0 p-2 z-20">
            <button (click)="onClickCloseExtendInfo()"
                    class="focus:outline-none p-1.5 w-6 h-6 mb-4 flex items-center justify-center bg-info border border-info rounded-full transition ease-out duration-300 hover:border-primary">
                <img src="./assets2023/img/icons/close.svg" alt="Cerrar" width="8" height="8"/>
            </button>
        </div>

        <div class="absolute left-0 right-0 pb-2">
            <div class="flex gap-5 mt-5 ml-4">
                <div id="product-gallery-wrapper" class="flex-shrink-0 gap-5 w-full md:w-auto opacity-0 transition-opacity duration-500 ease-out">
                    <section class="w-250px" style="height: 380px">
                        <!-- Main Carrusel -->
                        <div id="carousel-product-main" class="carousel carousel-modal mb-2">
                            <div class="carousel-cell-mini js-carousel-cell" *ngFor="let image of productMoreImagesBig">
                                <img
                                    [src]="(isfullscreen) ? image : 'https://axhygnxuen.cloudimg.io/height/250/n/'+image"
                                    [title]="(isfullscreen) ? '' : ('product_zoom' | translate)"
                                    class="max-h-img-gallery-mini carousel-cell-image"
                                />
                            </div>
                        </div>

                        <!-- Thumbnails Carrusel -->
                        <div id="carousel-product-nav" class="h-100px mt-3">
                            <div class="cursor-pointer mx-4 js-carousel-cell h-100px inline" *ngFor="let image of productMoreImagesSmall">
                                <img [src]="'https://axhygnxuen.cloudimg.io/height/65/n/'+image" class="h-th-gallery max-w-th-gallery">
                            </div>
                        </div>
                    </section>
                </div>

                <div *ngIf="item.info.veretiquetado" class="flex-shrink-0 space-y-5">
                    <div class="efficiency-tag" *ngIf="showOldLabel(item)">
                        <img class="max-w-200px max-h-250px efficiency-tag__img" src="assets/img/neumatico-etiqueta.jpg">

                        <p class="efficiency-tag__gas efficiency-tag__gas--{{item.info.consumo | lowercase}}">{{item.info.consumo}}</p>
                        <p class="efficiency-tag__rain efficiency-tag__rain--{{item.info.agarre | lowercase}}">{{item.info.agarre}}</p>
                        <p class="efficiency-tag__noise">{{item.info.ruido}}</p>
                    </div>
                    <div class="efficiency-tag-new" *ngIf="showNewLabel(item)">
                        <!-- Etiqueta -->
                        <img class="max-w-200px max-h-250px" src="assets/img/neumatico-etiqueta-new-completa.png" *ngIf="item.info.hielo && item.info.nieve">
                        <img class="max-w-200px max-h-250px" src="assets/img/neumatico-etiqueta-new-basica.png" *ngIf="!item.info.hielo && !item.info.nieve">
                        <img class="max-w-200px max-h-250px" src="assets/img/neumatico-etiqueta-new-nieve.png" *ngIf="!item.info.hielo && item.info.nieve">
                        <img class="max-w-200px max-h-250px" src="assets/img/neumatico-etiqueta-new-hielo.png" *ngIf="item.info.hielo && !item.info.nieve">

                        <!-- QR -->
                        <qrcode *ngIf="item.info.codigoqr" class="efficiency-tag-new__qr" [qrdata]="item.info.codigoqr" usesvg="true"></qrcode>
                        <!-- Marca -->
                        <p class="efficiency-tag-new__brand">{{item.info.marca}}</p>
                        <!-- Proveedor -->
                        <p class="efficiency-tag-new__provider">{{item.info.referenciaProveedor}}</p>
                        <!-- Tamaño -->
                        <p class="efficiency-tag-new__size">{{item.info.ancho}}/{{item.info.perfil}}R{{item.info.llanta}} {{item.info.carga}}{{item.info.velocidad}}</p>
                        <!-- Clase -->
                        <p class="efficiency-tag-new__class">{{item.info.etiquetado2}}</p>
                        <!-- Ruido -->
                        <p class="efficiency-tag-new__noise">{{item.info.ruido}}</p>
                        <!-- Consumo -->
                        <p class="efficiency-tag-new__gas efficiency-tag-new__gas--{{item.info.consumo | lowercase}}">{{item.info.consumo}}</p>
                        <!-- Agarre -->
                        <p class="efficiency-tag-new__rain efficiency-tag-new__rain--{{item.info.agarre | lowercase}}">{{item.info.agarre}}</p>
                        <!-- Ruido -->
                        <p class="efficiency-tag-new__noise">{{item.info.ruido}}</p>
                        <!-- Honda -->
                        <p class="efficiency-tag-new__honda efficiency-tag-new__honda--{{item.info.onda | lowercase}}">
                            <span class="efficiency-tag-new__honda-a">A</span>
                            <span class="efficiency-tag-new__honda-b">B</span>
                            <span class="efficiency-tag-new__honda-c">C</span>
                        </p>
                    </div>
                    <a
                        *ngIf="item.info.consumo.trim() !== '-' && item.info.consumo.trim() !== ''"
                        class="flex items-center font-medium gap-2 hover:underline"
                        href="{{ getPrintLabelUrl(item) }}"
                        target="_blank"
                    >
                        <img src="./assets2023/img/icons/print.svg" alt="Imprimir"/>
                        <span>{{ 'product_table_print'|translate }}</span>
                    </a>
                </div>

                <div class="flex-1 flex-shrink-0 pl-10 xl:pl-14 mb-6 whitespace-normal" style="max-height: 285px;">
                    <app-product-stock-info-tabs
                        [item]="item"
                        [productMoreInfo]="productMoreInfo"
                        [productStock]="productStock"
                        [empresa]="empresa"
                    ></app-product-stock-info-tabs>
                </div>
            </div>

        </div>
    </div>
</div>
